import * as React from "react";
import * as $ from "jquery";
import { Uploader } from '../lib/components/Uploader';
import { ImageEditor } from '../lib/components/ImageEditor';
import { ImageResizer } from '../lib/components/ImageResizer';

interface MyWindows extends Window{
	canvasParameters: any;
}
declare var window:any;

interface ICropImageSize{
    width: number
    height: number
}

interface ICropImageUploaderProps {
    file          : string
    x             : number
    y             : number
    scale         : number
	setFile       : Function
    refreshCanvas : Function
    uploadButtonName: string
    sizes         ?: Array<ICropImageSize>
    cropSize      ?: ICropImageSize
    removeLabel   : string
}

interface IUploadStatus{
	fileName:string
	status:boolean
}

interface ICropImageUploaderState {
	file       : string
	file_name  : string
	extensions : Array<string>
	sizes      : Array<ICropImageSize>
	cropSize   : ICropImageSize
	errors     : Array<string>
}

export default class CropImageUploader extends React.Component<ICropImageUploaderProps, ICropImageUploaderState>{

	private uploadStatus:Array<IUploadStatus>;

	constructor(props:ICropImageUploaderProps){
		super(props);
		// set initial state
		this.uploadStatus = [];
		this.state = this.getInitState();
    }

	protected getInitState():any{
		return {
            file          : '',
			file_name     : '',
			extensions    : [
				'jpg',
				'png',
				'jpeg'
			],
			sizes         : [
        		{
        			width: 800,
        			height: 600
        		}
            ],
			cropSize     : {
        			width: 168,
        			height: 168
        	},
			errors        : []
        };
	}

	submitHandler(items):void {
		if ( items.length > 0 ) {
            if ( window.temp === undefined) {
                window.temp = {};
            }
			window.temp.originalFile = items[0].file;
			this.setState({
	            file: items[0].file,
	            file_name: items[0].file_name
	        } as ICropImageUploaderState);
            $('.scrollBar').toggleClass('hide');
            $('#scroll_image, .scrollBar .row').css('visibility', 'visible');
		}else{
			return;
		}
		this.uploadStatus.push({
			fileName: this.state.file_name,
			status: false
		});
	}

	private checkUploadsCompleted():boolean{
		var max:number = this.uploadStatus.length;
		var completed:number = 0;
		for (let i = 0; i < max; i++) {
			if ( this.uploadStatus[i].status === true ) {
				++completed;
			}
		}
		if ( max === completed ) {
			return true;
		}
		return false;
	}

	private triggerUploadClickHandler(evt): void {
		evt.preventDefault();
		$('.crop_image_uploader .file_uploader_btn').trigger('click');
	}

    private removeClickHandler(evt): void {
        evt.preventDefault();
		this.props.setFile(null);
        (window as MyWindows).canvasParameters = null;
        this.setState({
            file: '',
            file_name: ''
        } as ICropImageUploaderState);
    }

    private canvasChangedHandler(positions:any): void {
        var width:number  = 95;
        var height:number  = 95;
        if ( this.props.cropSize !== undefined ) {
            width = this.props.cropSize.width;
            height = this.props.cropSize.height;
        }
        // tslint:disable-next-line:no-unused-expression
        new ImageResizer(this.getImgSource(), width, height, (ret)=>{
            if ( window.temp === undefined) {
                window.temp = {};
            }
            window.temp.smallFile = ret;
            this.props.refreshCanvas(positions);
        });
    }

    protected getImgSource():string{
        var canvas:HTMLCanvasElement = document.getElementById('image_editor') as HTMLCanvasElement;
		if ( this.isCanvasBlank(canvas) ) {
			return '';
		}else{
			return canvas.toDataURL("image/jpeg");
		}
    }

	protected isCanvasBlank(canvas):boolean {
        if ( document.createElement('canvas') === null || canvas === null ) {
            return true;
        }
	    var blank = document.createElement('canvas');
	    blank.width = canvas.width;
	    blank.height = canvas.height;
	    return canvas.toDataURL() === blank.toDataURL();
	}

    render() {
		var file = this.state.file;
        if ( this.state.file_name === '' && this.props.file !== '' && this.props.file !== null  ) {
            file = this.props.file;
        }
		var removeBtnStyle:any = {};
		var uploadBtnStyle:any = {};
		if ( file === '' ) {
			removeBtnStyle = {
				display: 'none'
			};
		}else{
            uploadBtnStyle = {
                display: 'none'
            };
        }
        var uploaderSize = this.state.sizes;
        if ( this.props.sizes !== undefined ) {
            uploaderSize = this.props.sizes;
        }
        var cropSize = this.state.cropSize;
        if ( this.props.cropSize !== undefined ) {
            cropSize = this.props.cropSize;
        }
        return (
			<div className="crop_image_uploader">
                <ImageEditor
                  key = {'image_editor_profile_header' }
                  img={ file }
                  width={ cropSize.width }
                  height={ cropSize.height }
                  x={ this.props.x }
                  y={ this.props.y }
                  scale={ this.props.scale }
                  refreshCanvas={ positions => this.canvasChangedHandler(positions) }
                />
				<button type="button" className="btn uploader_btn" style={ uploadBtnStyle } onClick={ e => this.triggerUploadClickHandler(e) }>{ this.props.uploadButtonName }</button>
				<button type="button" className="btn remove_btn" style={ removeBtnStyle } onClick={ e => this.removeClickHandler(e) }>{ this.props.removeLabel }</button>
				<Uploader extensions={this.state.extensions} sizes={ uploaderSize } max_files={1} resizeCallback={ items => this.submitHandler(items) } display_uplodader={false} />
			</div>
        );
    }
}



// WEBPACK FOOTER //
// ./components/CropImageUploader.tsx